// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { MAMode } from '../../IndicatorConstants';
import { ExpandDoubleVector } from '../../DoubleMatrix';
import { IndicatorFunctions } from '../../IndicatorFunctions';
import { iBuildInIndicator } from '../../iBuildInIndicator';
export const iAC = 'iAC';
export class IAC extends iBuildInIndicator {
    constructor() {
        super(1);
        this.ao = new ExpandDoubleVector();
        this.ma = new ExpandDoubleVector();
    }
    get Name() {
        return iAC;
    }
    get Key() {
        return this.DefaultKey;
    }
    NextBar(callBound) {
        super.NextBar(callBound);
        this.ma.Add(0.0);
        this.ao.Add(0.0);
    }
    Refresh(count, newThread) {
        this.ma.Dispose();
        this.ao.Dispose();
        this.ma = new ExpandDoubleVector();
        this.ao = new ExpandDoubleVector();
        super.Refresh(count, newThread);
    }
    OnQuote() {
        const Parent = this.Parent;
        if (!Parent) {
            return;
        }
        const close = this.GetPrice(PriceType.Close, 0);
        this.ao[this.ao.Length - 1] = close;
        if (this.Count >= 39) {
            this.ma[this.ma.Length - 1] = IndicatorFunctions.AOFunction(this.ao);
            this.SetValue(0, 0, this.ma[this.ma.Length - 1] - IndicatorFunctions.CallMovingFunction(MAMode.SMA, this.ma, 5, 1));
        }
    }
}
